/**
 * Provider → logo asset mapping, shared by the Models listing, the model
 * drawers and the Agent Designer's Configure panel so the same iconography is
 * used everywhere (matches the byom-v2-option2 prototype's providerLogoImg()).
 */
import openaiLogo from '@assets/boomi-ai/ui-kit/agentFoundation/openai-logo.png';
import customCloud from '@assets/boomi-ai/ui-kit/agentFoundation/custom-cloud.svg';
import type { ModelProvider } from '@components/ModelsManagement/types/models.types';
import boomiFavicon from '@assets/boomi-ai/ui-kit/agentFoundation/boomi-logo.png';
import googleLogo from '@assets/boomi-ai/ui-kit/agentFoundation/google-logo.png';
import anthropicLogo from '@assets/boomi-ai/ui-kit/agentFoundation/anthropic-logo.png';

export interface ModelProviderLogo {
  src: string;
  alt: string;
}

export default function modelProviderLogo(
  provider: ModelProvider | string,
  boomi = false,
): ModelProviderLogo {
  if (boomi || provider === 'Boomi') return { src: boomiFavicon, alt: 'Boomi' };
  switch (provider) {
    case 'Anthropic':
    case 'anthropic':
      return { src: anthropicLogo, alt: 'Anthropic' };
    case 'OpenAI':
    case 'openai':
      return { src: openaiLogo, alt: 'OpenAI' };
    case 'Gemini':
    case 'gemini':
      return { src: googleLogo, alt: 'Gemini' };
    case 'Google':
    case 'google':
      return { src: googleLogo, alt: 'Google' };
    default:
      return { src: customCloud, alt: provider || 'Custom' };
  }
}
